import React from 'react';

import { ModalSize } from 'app/shared/componentsRestyled/coreDesignSystem/Modals';

import ContactTypeForm from './ContactTypeForm';

export const getContactTypeDialogProps = ({ contactType, afterAcceptCallback } = {}) => {
  const isEditMode = !!contactType?.id;

  return {
    withButtons: true,
    withDivider: true,
    onAcceptButtonName: 'Save',
    size: ModalSize.LARGE,
    isRestyled: true,
    header: `${isEditMode ? 'Edit' : 'New'} Contact Type`,
    body: dialogProps => (
      <ContactTypeForm
        {...dialogProps}
        afterAcceptCallback={afterAcceptCallback}
        contactTypeInitialData={contactType}
      />
    ),
  };
};
